<template>
    <div id="app">
        <vue-progress-bar></vue-progress-bar>

        <navbar></navbar>

        <router-view></router-view>

        <div class="sticky-footer-spacing"></div>
        <!-- <footer-main></footer-main> -->
    </div>
</template>

<script>
export default {
    name: 'app',
    created () {
        if ( this.$Tawk ) {
            this.$Tawk.$startChat()
        }
    }
}
</script>

<style>
    @import 'https://cdn.jsdelivr.net/fontawesome/4.7.0/css/font-awesome.min.css';
</style>
